export const ENABLE_USER_WELCOME_URL_EDIT = 'enable_user_welcome_url_edit';
